import { useNavigate } from 'react-router-dom';
import { Chrome } from '@/components/layout/Chrome';

export const ThankYouPage = () => {
  const navigate = useNavigate();
  return (
    <Chrome>
      <div className="relative flex min-h-[60vh] items-center justify-center overflow-hidden p-6">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/hero-bg.jpg')" }}
        />
        <div
          className="absolute inset-0 z-[1]"
          style={{ background: 'rgba(0,229,192,.45)', mixBlendMode: 'multiply' }}
        />
        <div className="relative z-[2] w-full max-w-lg rounded-sm bg-navy p-8 text-center shadow-cardLg md:p-12">
          <h1 className="mb-5 text-2xl font-black uppercase leading-tight text-white md:text-3xl">
            Thank you for your submission
          </h1>
          <p className="mb-6 text-xs leading-relaxed text-white">
            We've received your registration. Our team will be in touch shortly to complete any
            outstanding checks.
          </p>
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="rounded-sm bg-teal px-6 py-3.5 text-xs font-extrabold uppercase tracking-[2px] text-navy transition-colors hover:bg-teal-dark"
          >
            Back to Login
          </button>
        </div>
      </div>
    </Chrome>
  );
};
